import {modal} from './init-modal';

const initLeavePageModal = () => {
  const leavePageModal = document.getElementById('leave-page-modal');  

  if (leavePageModal) {    
    const buttonToForm = leavePageModal.querySelector('.appearing-modal__button'),
      forms = document.querySelectorAll('form');
    let statusModal = false;

    /* Отключение модального окна при заполнении формы */
    if (forms.length > 0) {
      forms.forEach(form => {
        form.addEventListener('click', () => {
          statusModal = true;
          removeEventOpenModal();
        })
      })
    }

    /* Вывод модального окна при перемещении курсора за пределы сайта */
    const documentLeaveHandle = (evt) => {

      if (!evt.toElement && !evt.relatedTarget) {
        openModalWindow();
      }
    };

    /* Вывод моального окна при неактивности более 10 сек */
    let timeout;
    const eventHandlerHiddenElement = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        openModalWindow();        
      }, 10000);
    }

    /* Открытие модального окна */
    function openModalWindow() {
      if (statusModal == true) return;
      const activeModal = document.querySelector('.custom-modal.active');

      if (activeModal) return;

      statusModal = true;
      modal.openModal(leavePageModal);
      removeEventOpenModal();

      buttonToForm.addEventListener('click', () => {
        modal.closeModal();
        
        if (!document.querySelector('#form')) {
          window.location.href = '/#form';
        } else {
          document.querySelector('#form').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        };
      });
    }

    /* Удаления событий открытия модального окна */
    function removeEventOpenModal() {
      document.removeEventListener("mouseout", documentLeaveHandle);
      document.removeEventListener("mousemove", eventHandlerHiddenElement);
      document.removeEventListener("scroll", eventHandlerHiddenElement);
      leavePageModal.removeAttribute('data-modal-open');
    }

    /*  */
    setTimeout(() => {
      document.addEventListener("mouseout", documentLeaveHandle);
      document.addEventListener("mousemove", eventHandlerHiddenElement);
      document.addEventListener("scroll", eventHandlerHiddenElement);
    }, 120000);
  };
};

export default initLeavePageModal;
